// HeldCreditBanner — Jun 2026 (Randy). Shows held voucher credit (money topped
// up before a silo existed) at the TOP of Account & Billing, above the whole
// feature, so a creator who paid from here sees the result right where they
// paid — instead of only on the Dashboard.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wallet } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function HeldCreditBanner() {
  const [held, setHeld] = useState(0);
  const [byProvider, setByProvider] = useState(null);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const r = await api.get("/me/voucher-summary");
        if (cancel) return;
        setHeld(Number(r.data?.held_topup_cents) || 0);
        setByProvider(r.data?.held_topup_by_provider_cents || null);
      } catch { /* silent */ }
    })();
    return () => { cancel = true; };
  }, []);

  if (held <= 0) return null;

  const split = byProvider
    ? `($${((byProvider.gemini || 0) / 100).toFixed(2)} Gemini · $${((byProvider.anthropic || 0) / 100).toFixed(2)} Anthropic · $${((byProvider.openai || 0) / 100).toFixed(2)} OpenAI)`
    : "";

  return (
    <div
      className="rounded-xl border border-[#4A5D4E]/40 bg-[#E8EBE5]/70 px-4 py-3.5 flex items-start gap-3"
      data-testid="account-held-credit-banner"
    >
      <Wallet size={20} weight="duotone" className="text-[#2F6B3A] shrink-0 mt-0.5" />
      <div className="text-sm text-[#3A4A3E] leading-relaxed">
        <strong data-testid="account-held-credit-amount">
          ${(held / 100).toFixed(2)} in platform credit is paid, held and ready.
        </strong>{" "}
        Your top-up was dispersed evenly across all three AI platforms {split} and is being held safely —
        it drops straight into your first silo the moment you create one. Nothing is lost.
        <Link
          to="/dashboard"
          data-testid="account-held-credit-create-silo"
          className="ml-2 underline font-medium text-[#2F6B3A] hover:text-[#1C1B1A] transition-colors"
        >
          Create your first silo →
        </Link>
      </div>
    </div>
  );
}
